import React from "react";
import {
  Box,
  Typography,
  Divider,
  useTheme,
} from "@mui/material";

const Disclaimer = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: "#f4f6f8", py: 6, px: { xs: 3, sm: 8, md: 12 }, minHeight: "100vh" }}>
      <Box
        sx={{
          bgcolor: "#ffffff",
          borderRadius: 2,
          boxShadow: 2,
          p: { xs: 3, sm: 5, md: 7 },
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 700, color: "#0A1929" }}
        >
          Disclaimer
        </Typography>

        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ color: "text.secondary", mb: 3 }}
        >
          Effective Date: August 01, 2025
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Welcome to <strong>Workpulse.in</strong> – an online platform designed to streamline project and task
          management across multiple entities and user hierarchies. Please read this disclaimer carefully before using our
          website or services. By accessing or using <strong>Workpulse.in</strong>, you agree to the terms of this disclaimer,
          our Terms of Service, and Privacy Policy.
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          1. No Professional Advice
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The information, analytics, and content available on <strong>Workpulse.in</strong> are provided for general
          project and task management purposes only. We do not offer legal, financial, or professional advice. Users are solely
          responsible for decisions and actions taken based on the platform.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          2. User-Generated Content
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Users are responsible for the accuracy, completeness, and legality of the content they upload. This includes task
          details, project updates, entity records, and assignments. <strong>Workpulse.in</strong> does not verify or audit
          user content.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          3. Data Security & Access
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          While appropriate security measures are in place, absolute data security cannot be guaranteed. Access is role-based
          (Admin, Manager, Member), and users are responsible for maintaining the confidentiality of login credentials.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          4. Third-Party Integrations
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          <strong>Workpulse.in</strong> may integrate with third-party services. We are not responsible for their content,
          policies, or operations.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          5. Availability and Downtime
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The platform may be temporarily unavailable due to maintenance or unforeseen issues. We are not liable for any loss
          arising from such downtime.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          6. Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          <strong>Workpulse.in</strong>, its owners, and affiliates shall not be liable for indirect, incidental, or
          consequential damages from the use of the platform, including errors, data loss, or unauthorized access.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          7. Changes to This Disclaimer
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          We may update this disclaimer at any time. Continued use of the platform after updates constitutes acceptance of
          the revised terms.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          8. Contact
        </Typography>
        <Typography variant="body1">
          If you have any questions, please contact us at <strong>workpulse.in@gmail.com</strong>.
        </Typography>
      </Box>
    </Box>
  );
};

export default Disclaimer;
